<div class="pos-relative video-component"
     [ngClass]="component.ratio || ''">

    <!-- image -->
    @if (component.background_image) {
    <img class="z-1"
         [class.rf]="!!component.ratio"
         [dfImage]="component.background_image"
         [ratio]="component.ratio || ''"
         [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
         fill>
    }

    @if (component.video_id && !component.video_hide) {
    @if (component.video_provider === 'youtube') {
    <youtube-player class="z-2"
                    [class.rf]="!!component.ratio"
                    [video-id]="component.video_id"
                    [autoplay-in-viewport]="component.video_autoplay"
                    [background]="component.video_background">
        <!-- play icon -->
        <ng-template #playButton>
            <button class="video-icon">
                <i class="col-w icon-play"
                   aria-hidden="true"></i>
            </button>
        </ng-template>

        <!-- pause icon -->
        <ng-template #pauseButton>
            <button class="video-icon">
                <i class="col-w icon-pause"
                   aria-hidden="true"></i>
            </button>
        </ng-template>
    </youtube-player>
    }

    @if (component.video_provider === 'vimeo') {
    <local-vimeo-player class="z-2"
                        [class.rf]="!!component.ratio"
                        [video-id]="component.video_id"
                        [autoplay-in-viewport]="component.video_autoplay"
                        [background]="component.video_background">
        <!-- play icon -->
        <ng-template #playButton>
            <button class="video-icon">
                <i class="col-w icon-play"
                   aria-hidden="true"></i>
            </button>
        </ng-template>

        <!-- pause icon -->
        <ng-template #pauseButton>
            <button class="video-icon">
                <i class="col-w icon-pause"
                   aria-hidden="true"></i>
            </button>
        </ng-template>
    </local-vimeo-player>
    }
    }
</div>
